import { Typography, Avatar, Rating } from "@material-tailwind/react";

export function Reviews() {
  const data = [
    {
      name: "Math Saf.",
      message:
        "Ma fille est dans cette école depuis 3 année déjà et j'en suis vraiment satisfaite. Al hamdouliLlah chaqune des maîtresse qu'elle a eu ont été douce patiente gentille et surtout de vraie résultat dans le travail. Qu Allah preserve notre école 🥰",
      rating: 5,
    },
    {
      name: "Oum Ibnati.",
      message:
        "Superbe école !!! très satisfaite de l enseignement. C'est une vraie ni3maa, dommage qu'il n'y ait pas davantage d écoles privées musulmanes à Marseille , afin que d autres enfants bénéficient d un enseignement de qualité comme celui de l école l olivier, car les places sont limitées.",
      rating: 5,
    },
    {
      name: "Sonia Bichiou.",
      message:
        "Ma fille est en petite section. Elle est heureuse et va à l'école en courant. La maîtresse et la tata sont vraiment efficaces. Merci à elles. Je ne regrette pas mon choix. Bien au contraire.",
      rating: 5,
    },
  ];

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 py-8 px-6">
      {data.map((review, index) => (
        <div
          key={index}
          className="card flex flex-col justify-between gap-3 w-full p-6 border-2 border-resedaGreen rounded-lg"
        >
          <div className="header-review flex items-center justify-between">
            <div className="left-header-review flex items-center gap-2">
              <Avatar src='/assets/images/logo-lolivier_nav.ico' alt="avis d'utilisateur" size="sm" />
              <div className="flex flex-col">
                <Typography variant="h4" className=" text-black text-sm font-bold">
                  {review.name}
                </Typography>
                <Typography variant="small" className="text-gray-600 text-sm ">
                  Parent d'éleve
                </Typography>
              </div>
            </div>
            <div className="right-header-review">
              <Rating value={Math.round(review.rating)} readonly />
            </div>
          </div>
          <Typography variant="paragraph" className="text-sm xl:text-lg">{review.message}</Typography>
          <div className="footer-review flex justify-between">
            <span className="inline-block mt-3 px-3 py-1 text-xs font-medium rounded-full bg-vertLogo text-white">
              ✔ Avis vérifié
            </span>

            <Typography
              variant="small"
              className="text-gray-600 mt-3 text-right"
            >
              Posté en mars 2025
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
}
